"use client"
import { useState } from 'react';
import { motion } from 'framer-motion';
import { Search, Calendar, ArrowRight } from 'lucide-react';
import { cn } from "@/lib/utils";
import SharedHero from '@/components/ui/shared-hero';
import CreativeCanvas from './creative-canvas';
import Link from 'next/link';


import { resourcesData } from './post-data';

const Resources = () => {
    // Filter resources based on active tag
    const filteredResources = resourcesData;

    return (
        <div className="min-h-screen font-jakarta bg-white">
            <SharedHero
                label="Resources"
                title="Resources & Insights"
                subtitle="Expert guides, industry insights, and practical tips to help you build better businesses."
            />


            {/* Resources Grid */}
            <div className="max-w-[1440px] mx-auto px-6 lg:px-12 pt-16">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10">
                    {filteredResources.map((item, index) => (
                        <Link
                            href={`/resources/${item.id}`}
                            key={item.id}
                            className="block h-full group cursor-pointer"
                        >
                            <motion.div
                                initial={{ opacity: 0, y: 10 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.3 }}
                                className="flex flex-col h-full bg-[#ffffff] rounded-xl overflow-hidden hover:shadow-xl hover:shadow-blue-900/5 transition-all duration-300 border border-gray-100 hover:border-blue-100"
                            >
                                <div className="h-64 w-full relative">
                                    <CreativeCanvas
                                        title={item.title}
                                        category={item.series}
                                        index={index}
                                    />


                                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors duration-300" />
                                </div>


                                <div className="px-5 py-4 border-t border-gray-100 bg-white flex items-center justify-between">
                                    <span className="text-[12px] font-bold text-gray-500">
                                        Read Article
                                    </span>
                                    <div className="flex items-center gap-1.5 text-xs text-gray-400 font-medium font-jakarta">
                                        <Calendar size={12} className="text-gray-300" />
                                        {item.date}
                                        <ArrowRight size={12} className="ml-1 opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all duration-300 text-blue-600" />
                                    </div>
                                </div>
                            </motion.div>
                        </Link>
                    ))}
                </div>
            </div>

            {/* View More Button */}
            {/* <div className="mt-20 text-center">
                <button className="group inline-flex items-center gap-2 px-6 py-2.5 bg-white border border-gray-200 text-gray-600 rounded-full font-jakarta font-bold text-[13px] hover:border-[#2563EB] hover:text-[#2563EB] transition-all duration-300 shadow-sm hover:shadow-md">
                    Load more articles
                    <ArrowRight size={14} className="group-hover:translate-x-0.5 transition-transform duration-300" />
                </button>
            </div> */}
        </div>
    );
};

export default Resources;
